export const priceLevels = {
  Basic: '0',
  Level_1: '1',
  Level_2: '2',
  Level_3: '3',
  Level_4: '4',
  Level_5: '5'
};

export const mappedPriceLevels = Object.entries(priceLevels)
  .map(([key]) => ({ value: key, label: key }));